const comitentTypeFromJMBG = (value) => {
  if (!value) return null;
  const gender = value.substring(0, 1);
  return Number(gender) == 4 ? 'P' : 'F';
};

export default comitentTypeFromJMBG;
